































import i18n from "../../i18n";
import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import GTopicSubject from '@/components/GTopicSubject.vue';
import GLoading from '@/components/GLoading.vue';
import { GEnum } from '@/constants/enum.defination';

@Component({
  components: { GLoading, GTopicSubject },
  computed: {},
  methods: {},
})
export default class GTopicFormForTrendAnalysis extends mixins(GPageBase) {
  isTimer: boolean = true;
  timer: number;

  @Prop() isShowContentCondition: boolean;
  @Prop({ default: i18n.t('NOTICE_DATA_NOT_LOAD') })
  errorText: string;

  mounted() {
    this.startTimer();
  }

  startTimer() {
    this.isTimer = true;
    const self: any = this;
    clearTimeout(this.timer);
    this.timer = window.setTimeout(() => {
      self.isTimer = false;
    }, 30000);
  }

  get isDisplayTrend(): boolean {
    // 追加サービスプランに傾向チェックが含まれている場合、表示する
    return this.$store.state.account.additionalPlanTypes.includes(GEnum.AdditionalPlanType.TrendCheckAcademic) ||
           this.$store.state.account.additionalPlanTypes.includes(GEnum.AdditionalPlanType.TrendCheckAcademicReadOnly);
  }
}
